import { createContext, useContext } from 'react';

export interface SecurityContextType {
  isSecureConnection: boolean;
  browserSupported: boolean;
  securityWarnings: string[];
}

export const SecurityContext = createContext<SecurityContextType | undefined>(undefined);

export const useSecurityContext = () => {
  const context = useContext(SecurityContext);
  if (context === undefined) {
    throw new Error('useSecurityContext must be used within a SecurityProvider');
  }
  return context;
};